import { TileConcreteDisplayProps } from './TileAbstractDisplay.js';
import { CanvasCircleRenderer } from '../renderers/CanvasCircleRenderer.js';

export const CanvasCircleDisplay = (props: TileConcreteDisplayProps) => {
  const {
    center: { x, y },
    fillColor,
    width,
    value,
    name,
    truncationMode,
    showLabels,
  } = props;
  const halfWidth = width / 2;

  return (
    <CanvasCircleRenderer
      x={x}
      y={y}
      name={name}
      value={value}
      radius={halfWidth}
      fillColor={fillColor}
      strokeColor="transparent"
      truncationMode={truncationMode}
      showLabels={showLabels}
    />
  );
};

CanvasCircleDisplay['displayName'] = 'CanvasCircleDisplay';
